export default __webpack_public_path__ + "652bb58060650f721c396624f3b4b45c.png";